export const shouldEnableAppShellBootstrap = (input: {
  hasAuthenticatedSession: boolean;
  isEntryAuthFlow: boolean;
}): boolean => {
  return input.hasAuthenticatedSession && !input.isEntryAuthFlow;
};

export const shouldQueryAppShellEntitlements = (input: {
  activePath: string;
  isEntryAuthFlow: boolean;
  nonCriticalShellEnabled: boolean;
  projectsLoaded: boolean;
}): boolean => {
  if (input.isEntryAuthFlow) return false;
  if (!input.projectsLoaded) return false;
  if (input.nonCriticalShellEnabled) return true;
  return isEntitlementSensitiveShellPath(input.activePath);
};

const entitlementSensitivePathPrefixes = [
  '/coverage-runs',
  '/directories',
  '/features',
  '/files',
  '/jobs',
  '/pipelines',
  '/releases',
  '/stages',
];

const isEntitlementSensitiveShellPath = (activePath: string): boolean =>
  entitlementSensitivePathPrefixes.some(
    (prefix) => activePath === prefix || activePath.startsWith(`${prefix}/`),
  ) ||
  /\/(coverage-runs|directories|features|files|jobs|pipelines|releases|stages)(?:\/|$)/.test(
    activePath,
  );
